import { useFormatter } from "use-intl";

export function useDateTimeFormatter() {
  const format = useFormatter();

  return (date: Date) =>
    format.dateTime(date, {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
}

export function useShortDateTimeFormatter() {
  const format = useFormatter();

  return (date: Date | string | null | undefined) => {
    if (date === null || date === undefined) {
      return null;
    }

    if (typeof date === "string") {
      date = new Date(date);
    }

    return format.dateTime(date, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
    });
  };
}
